exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 991px) {\n.pl-4[data-v-7db114d7], .px-4[data-v-7db114d7] {\n        padding-left: 1rem !important;\n}\n}\n#bonus-terms-table[data-v-7db114d7] {\n    margin: 20px auto 10px;\n}\n#bonus-terms-table th[data-v-7db114d7], #bonus-terms-table td[data-v-7db114d7] {\n    border: 1px solid #535353;\n    text-align: center;\n    vertical-align: middle;\n    padding: 5px;\n}\n#bonus-terms-table th[data-v-7db114d7] {\n    font-weight: normal;\n}\n.no-bonus[data-v-7db114d7] {\n    background-color: #c0c0c0;\n}\n", ""]);

// exports
